import { z } from 'zod';
import { defineEndpoint } from '../define';

const params = z.object({ releaseId: z.string().uuid() });

/** Opt in to Slack DMs for this release (UCH-806). Idempotent; view cap + scope. */
export const watchRelease = defineEndpoint({
  method: 'PUT',
  path: '/v1/releases/:releaseId/watch',
  params,
  query: z.object({}),
  body: z.undefined(),
  response: z.undefined(),
  successStatus: 204,
});

export const unwatchRelease = defineEndpoint({
  method: 'DELETE',
  path: '/v1/releases/:releaseId/watch',
  params,
  query: z.object({}),
  body: z.undefined(),
  response: z.undefined(),
  successStatus: 204,
});
